/* ==========================================================
   ERICKA HOME - TESTIMONIAL / VIDEO SLIDER

   Features:
   - Infinite slider states
   - Previous / Next buttons
   - Navigation dots
   - Autoplay
   - Mouse drag
   - Mobile swipe
   - Click preview to open video modal
   - Prevent modal opening after a drag
   - Shopify Theme Editor support
   ========================================================== */

(function () {

  const SECTION_SELECTOR =
    '[data-ericka-videos-section]';


  /* ========================================================
     FIND SECTIONS
     ======================================================== */

  function getSections(root) {

    const scope =
      root || document;


    if (
      scope.matches &&
      scope.matches(SECTION_SELECTOR)
    ) {
      return [scope];
    }


    return Array.from(
      scope.querySelectorAll(
        SECTION_SELECTOR
      )
    );

  }


  /* ========================================================
     SETUP ONE SECTION
     ======================================================== */

  function setupVideoSection(section) {

    /* ------------------------------------------------------
       CLEAN PREVIOUS INITIALIZATION
       Important for Shopify Theme Editor
       ------------------------------------------------------ */

    if (
      typeof section._erickaVideosCleanup ===
      'function'
    ) {
      section._erickaVideosCleanup();
    }


    /* ======================================================
       ELEMENTS
       ====================================================== */

    const cards = Array.from(
      section.querySelectorAll(
        '[data-ericka-video-card]'
      )
    );


    const dots = Array.from(
      section.querySelectorAll(
        '[data-ericka-video-dot]'
      )
    );


    const prevButton =
      section.querySelector(
        '[data-ericka-videos-prev]'
      );


    const nextButton =
      section.querySelector(
        '[data-ericka-videos-next]'
      );


    const stage =
      section.querySelector(
        '[data-ericka-videos-stage]'
      );


    if (!cards.length) {
      return;
    }


    /* ======================================================
       STATE
       ====================================================== */

    let activeIndex =
      cards.findIndex(
        function (card) {
          return card.classList.contains(
            'is-active'
          );
        }
      );


    if (activeIndex < 0) {
      activeIndex = 0;
    }


    let autoplayTimer = null;


    const autoplayEnabled =
      section.dataset.autoplay ===
      'true';


    const autoplaySpeed =
      parseInt(
        section.dataset.autoplaySpeed,
        10
      ) || 5000;


    /* ======================================================
       UPDATE SLIDER
       ====================================================== */

    function updateSlider(nextIndex) {

      const total =
        cards.length;


      activeIndex =
        (
          (nextIndex % total) +
          total
        ) % total;


      const prevIndex =
        (
          activeIndex -
          1 +
          total
        ) % total;


      const nextCardIndex =
        (
          activeIndex +
          1
        ) % total;


      cards.forEach(
        function (card, index) {

          card.classList.remove(
            'is-active',
            'is-prev',
            'is-next'
          );


          if (
            index === activeIndex
          ) {

            card.classList.add(
              'is-active'
            );

          } else if (
            index === prevIndex
          ) {

            card.classList.add(
              'is-prev'
            );

          } else if (
            index === nextCardIndex
          ) {

            card.classList.add(
              'is-next'
            );

          }

        }
      );


      dots.forEach(
        function (dot, index) {

          const isActive =
            index === activeIndex;


          dot.classList.toggle(
            'is-active',
            isActive
          );


          dot.setAttribute(
            'aria-current',
            isActive
              ? 'true'
              : 'false'
          );

        }
      );

    }


    /* ======================================================
       NEXT / PREVIOUS
       ====================================================== */

    function nextSlide() {

      updateSlider(
        activeIndex + 1
      );

    }


    function previousSlide() {

      updateSlider(
        activeIndex - 1
      );

    }


    /* ======================================================
       AUTOPLAY
       ====================================================== */

    function stopAutoplay() {

      if (!autoplayTimer) {
        return;
      }


      window.clearInterval(
        autoplayTimer
      );


      autoplayTimer = null;

    }


    function startAutoplay() {

      stopAutoplay();


      if (
        !autoplayEnabled ||
        cards.length <= 1
      ) {
        return;
      }


      autoplayTimer =
        window.setInterval(
          nextSlide,
          autoplaySpeed
        );

    }


    /* ======================================================
       BUTTON NAVIGATION
       ====================================================== */

    function handleNextClick() {

      nextSlide();

      startAutoplay();

    }


    function handlePrevClick() {

      previousSlide();

      startAutoplay();

    }


    if (nextButton) {

      nextButton.addEventListener(
        'click',
        handleNextClick
      );

    }


    if (prevButton) {

      prevButton.addEventListener(
        'click',
        handlePrevClick
      );

    }


    /* ======================================================
       DOT NAVIGATION
       ====================================================== */

    const dotHandlers = [];


    dots.forEach(
      function (dot, index) {

        function handleDotClick() {

          const requestedIndex =
            parseInt(
              dot.dataset.videoIndex,
              10
            );


          updateSlider(
            Number.isNaN(
              requestedIndex
            )
              ? index
              : requestedIndex
          );


          startAutoplay();

        }


        dot.addEventListener(
          'click',
          handleDotClick
        );


        dotHandlers.push({
          dot: dot,
          handler: handleDotClick
        });

      }
    );


    /* ======================================================
       DRAG / SWIPE
       ====================================================== */

    let pointerId = null;

    let startX = 0;
    let currentX = 0;

    let isDragging = false;

    let suppressVideoClick = false;


    /*
     * How far the user needs to drag
     * before changing testimonial.
     */

    const swipeThreshold = 45;


    /*
     * Smaller threshold used only to determine
     * if this was a drag rather than a click.
     */

    const dragThreshold = 8;


    function handlePointerDown(event) {

      if (!stage) return;


      /*
       * Don't start dragging from slider
       * navigation controls.
       */

if (
  event.target.closest(
    '[data-ericka-videos-prev], ' +
    '[data-ericka-videos-next], ' +
    '[data-ericka-video-dot], ' +
    '[data-ericka-video-open]'
  )
) {
  return;
}


      pointerId =
        event.pointerId;


      startX =
        event.clientX;


      currentX =
        event.clientX;


      isDragging = true;

      suppressVideoClick = false;


      stopAutoplay();


      stage.classList.add(
        'is-dragging'
      );


      if (
        stage.setPointerCapture &&
        pointerId !== null
      ) {

        try {

          stage.setPointerCapture(
            pointerId
          );

        } catch (error) {
          /* Ignore unsupported capture errors */
        }

      }

    }


    function handlePointerMove(event) {

      if (
        !isDragging ||
        event.pointerId !== pointerId
      ) {
        return;
      }


      currentX =
        event.clientX;


      const distance =
        currentX -
        startX;


      /*
       * Once movement exceeds a few pixels
       * this is considered a drag, not a click.
       */

      if (
        Math.abs(distance) >
        dragThreshold
      ) {

        suppressVideoClick = true;

      }

    }


    function finishPointerGesture(event) {

      if (
        !isDragging ||
        (
          pointerId !== null &&
          event.pointerId !== pointerId
        )
      ) {
        return;
      }


      isDragging = false;


      if (stage) {

        stage.classList.remove(
          'is-dragging'
        );

      }


      const distance =
        currentX -
        startX;


      /*
       * Left swipe / drag
       * = next testimonial
       */

      if (
        distance <=
        -swipeThreshold
      ) {

        nextSlide();

      }


      /*
       * Right swipe / drag
       * = previous testimonial
       */

      else if (
        distance >=
        swipeThreshold
      ) {

        previousSlide();

      }


      /*
       * Restart the autoplay countdown
       * after user interaction.
       */

      startAutoplay();


      if (
        stage &&
        stage.releasePointerCapture &&
        pointerId !== null
      ) {

        try {

          stage.releasePointerCapture(
            pointerId
          );

        } catch (error) {
          /* Ignore capture errors */
        }

      }


      pointerId = null;


      /*
       * Keep click suppression alive long enough
       * for the browser's click event that follows
       * pointerup.
       */

      if (suppressVideoClick) {

        window.setTimeout(
          function () {

            suppressVideoClick = false;

          },
          250
        );

      }

    }


    if (stage) {

      stage.addEventListener(
        'pointerdown',
        handlePointerDown
      );


      stage.addEventListener(
        'pointermove',
        handlePointerMove
      );


      stage.addEventListener(
        'pointerup',
        finishPointerGesture
      );


      stage.addEventListener(
        'pointercancel',
        finishPointerGesture
      );

    }


    /* ======================================================
       VIDEO MODAL
       ====================================================== */

    const modal =
      section.querySelector(
        '[data-ericka-video-modal]'
      );


    const modalContent =
      section.querySelector(
        '[data-ericka-video-modal-content]'
      );


    const openButtons =
      Array.from(
        section.querySelectorAll(
          '[data-ericka-video-open]'
        )
      );


    const closeButtons =
      Array.from(
        section.querySelectorAll(
          '[data-ericka-video-close]'
        )
      );


    const templates =
      Array.from(
        section.querySelectorAll(
          '[data-ericka-video-template]'
        )
      );


    let previouslyFocusedElement =
      null;


    /* ------------------------------------------------------
       FIND VIDEO TEMPLATE
       ------------------------------------------------------ */

    function getVideoTemplate(
      videoId
    ) {

      return templates.find(
        function (template) {

          return (
            template.dataset
              .erickaVideoTemplate ===
            videoId
          );

        }
      );

    }


    /* ------------------------------------------------------
       OPEN MODAL
       ------------------------------------------------------ */

    function openVideoModal(button) {

      /*
       * User dragged the carousel.
       * Do not interpret the resulting click
       * as an instruction to open the video.
       */

      if (suppressVideoClick) {
        return;
      }


      if (
        !modal ||
        !modalContent
      ) {
        return;
      }


      const videoId =
        button.dataset.videoId;


      if (!videoId) {
        return;
      }


      const template =
        getVideoTemplate(
          videoId
        );


      if (!template) {
        return;
      }


      stopAutoplay();


      previouslyFocusedElement =
        document.activeElement;


      modalContent.innerHTML = '';


      modalContent.appendChild(
        template.content.cloneNode(
          true
        )
      );


      modal.classList.add(
        'is-open'
      );


      modal.setAttribute(
        'aria-hidden',
        'false'
      );


      document.documentElement
        .classList.add(
          'ericka-video-modal-open'
        );


      const video =
        modalContent.querySelector(
          'video'
        );


      if (video) {

        video.currentTime = 0;


        const playPromise =
          video.play();


        if (
          playPromise &&
          typeof playPromise.catch ===
            'function'
        ) {

          playPromise.catch(
            function () {
              /*
               * Some browsers can still block
               * autoplay. Controls remain available.
               */
            }
          );

        }

      }


      const closeButton =
        modal.querySelector(
          '.ericka-home-videos__modal-close'
        );


      if (closeButton) {

        closeButton.focus({
          preventScroll: true
        });

      }

    }


    /* ------------------------------------------------------
       CLOSE MODAL
       ------------------------------------------------------ */

    function closeVideoModal() {

      if (
        !modal ||
        !modalContent
      ) {
        return;
      }


      const video =
        modalContent.querySelector(
          'video'
        );


      if (video) {

        video.pause();

        try {

          video.currentTime = 0;

        } catch (error) {
          /* Safe fallback */
        }

      }


      modal.classList.remove(
        'is-open'
      );


      modal.setAttribute(
        'aria-hidden',
        'true'
      );


      document.documentElement
        .classList.remove(
          'ericka-video-modal-open'
        );


      /*
       * Destroy the instantiated video.
       * It will be recreated next time.
       */

      modalContent.innerHTML = '';


      if (
        previouslyFocusedElement &&
        typeof previouslyFocusedElement
          .focus === 'function'
      ) {

        previouslyFocusedElement.focus({
          preventScroll: true
        });

      }


      previouslyFocusedElement =
        null;


      startAutoplay();

    }


    /* ------------------------------------------------------
       OPEN BUTTONS
       ------------------------------------------------------ */

    const openHandlers = [];


    openButtons.forEach(
      function (button) {

        function handleOpenClick(
          event
        ) {

          /*
           * Important when preview itself
           * is inside a draggable card.
           */

          if (suppressVideoClick) {

            event.preventDefault();

            return;

          }


          openVideoModal(
            button
          );

        }


        button.addEventListener(
          'click',
          handleOpenClick
        );


        openHandlers.push({
          button: button,
          handler: handleOpenClick
        });

      }
    );


    /* ------------------------------------------------------
       CLOSE BUTTONS / BACKDROP
       ------------------------------------------------------ */

    const closeHandlers = [];


    closeButtons.forEach(
      function (button) {

        function handleCloseClick() {

          closeVideoModal();

        }


        button.addEventListener(
          'click',
          handleCloseClick
        );


        closeHandlers.push({
          button: button,
          handler: handleCloseClick
        });

      }
    );


    /* ------------------------------------------------------
       ESCAPE KEY
       ------------------------------------------------------ */

    function handleKeydown(event) {

      if (
        event.key === 'Escape' &&
        modal &&
        modal.classList.contains(
          'is-open'
        )
      ) {

        closeVideoModal();

      }

    }


    document.addEventListener(
      'keydown',
      handleKeydown
    );


    /* ======================================================
       INITIAL STATE
       ====================================================== */

    updateSlider(
      activeIndex
    );


    startAutoplay();


    /* ======================================================
       CLEANUP
       ====================================================== */

    section._erickaVideosCleanup =
      function () {

        stopAutoplay();


        /* Main buttons */

        if (nextButton) {

          nextButton.removeEventListener(
            'click',
            handleNextClick
          );

        }


        if (prevButton) {

          prevButton.removeEventListener(
            'click',
            handlePrevClick
          );

        }


        /* Dots */

        dotHandlers.forEach(
          function (item) {

            item.dot.removeEventListener(
              'click',
              item.handler
            );

          }
        );


        /* Drag / Swipe */

        if (stage) {

          stage.removeEventListener(
            'pointerdown',
            handlePointerDown
          );


          stage.removeEventListener(
            'pointermove',
            handlePointerMove
          );


          stage.removeEventListener(
            'pointerup',
            finishPointerGesture
          );


          stage.removeEventListener(
            'pointercancel',
            finishPointerGesture
          );

        }


        /* Modal */

        openHandlers.forEach(
          function (item) {

            item.button.removeEventListener(
              'click',
              item.handler
            );

          }
        );


        closeHandlers.forEach(
          function (item) {

            item.button.removeEventListener(
              'click',
              item.handler
            );

          }
        );


        document.removeEventListener(
          'keydown',
          handleKeydown
        );


        /*
         * Make sure an open modal doesn't survive
         * a Shopify Theme Editor refresh.
         */

        if (
          modal &&
          modal.classList.contains(
            'is-open'
          )
        ) {

          const video =
            modalContent
              ? modalContent.querySelector(
                  'video'
                )
              : null;


          if (video) {
            video.pause();
          }


          modal.classList.remove(
            'is-open'
          );


          modal.setAttribute(
            'aria-hidden',
            'true'
          );


          if (modalContent) {
            modalContent.innerHTML = '';
          }

        }


        document.documentElement
          .classList.remove(
            'ericka-video-modal-open'
          );

      };

  }


  /* ========================================================
     INITIALIZE
     ======================================================== */

  function initErickaVideoSliders(
    root
  ) {

    getSections(root).forEach(
      setupVideoSection
    );

  }


  /* ========================================================
     NORMAL PAGE LOAD
     ======================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initErickaVideoSliders(
          document
        );

      }
    );

  } else {

    initErickaVideoSliders(
      document
    );

  }


  /* ========================================================
     SHOPIFY THEME EDITOR
     ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initErickaVideoSliders(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:select',
    function (event) {

      initErickaVideoSliders(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      getSections(
        event.target
      ).forEach(
        function (section) {

          if (
            typeof section
              ._erickaVideosCleanup ===
            'function'
          ) {

            section
              ._erickaVideosCleanup();

          }

        }
      );

    }
  );

})();

/* ==========================================================
   ERICKA HOME - STEPS

   Desktop:
   Automatic rotation.

   Mobile:
   Sticky, scroll-driven step sequence.
   ========================================================== */

(function () {
  const SECTION_SELECTOR =
    '[data-ericka-steps-section]';

  const STEP_SELECTOR =
    '[data-ericka-step]';

  const MOBILE_QUERY =
    '(max-width: 767px)';


  /* ========================================================
     FIND SECTIONS INSIDE A GIVEN ROOT
     ======================================================== */

  function getSections(root) {
    const scope = root || document;

    if (
      scope.matches &&
      scope.matches(SECTION_SELECTOR)
    ) {
      return [scope];
    }

    return Array.from(
      scope.querySelectorAll(
        SECTION_SELECTOR
      )
    );
  }


  /* ========================================================
     INITIALIZE ONE SECTION
     ======================================================== */

  function setupStepsSection(section) {

    /*
     Clean up any previous initialization.
     Useful inside the Shopify Theme Editor.
    */

    if (
      typeof section._erickaStepsCleanup ===
      'function'
    ) {
      section._erickaStepsCleanup();
    }


    /*
     Clear a timer created by the previous
     version of the script, if it exists.
    */

    if (section._erickaStepsTimer) {
      clearInterval(
        section._erickaStepsTimer
      );

      section._erickaStepsTimer = null;
    }


    const steps = Array.from(
      section.querySelectorAll(
        STEP_SELECTOR
      )
    );

    if (!steps.length) return;


    let activeIndex = steps.findIndex(
      function (step) {
        return step.classList.contains(
          'is-active'
        );
      }
    );

    if (activeIndex < 0) {
      activeIndex = 0;
    }


    let hasRendered = false;
    let isScrollMode = false;

    let modeCleanup = function () {};

    const mobileMedia =
      window.matchMedia(
        MOBILE_QUERY
      );

    const reducedMotionMedia =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );


    const rotationSpeed =
      parseInt(
        section.dataset.stepSpeed,
        10
      ) || 4000;


    /* ======================================================
       ACTIVATE A STEP
       ====================================================== */

    function activateStep(index, forceUpdate) {
      const nextIndex =
        Math.max(
          0,
          Math.min(
            steps.length - 1,
            index
          )
        );

      if (
        hasRendered &&
        nextIndex === activeIndex &&
        !forceUpdate
      ) {
        return;
      }

      activeIndex = nextIndex;
      hasRendered = true;


      steps.forEach(
        function (step, stepIndex) {
          const isActive =
            stepIndex === activeIndex;

          step.classList.toggle(
            'is-active',
            isActive
          );


          /*
           Direction classes are only needed
           for the mobile scroll animation.
          */

          if (isScrollMode) {
            step.classList.toggle(
              'is-before',
              stepIndex < activeIndex
            );

            step.classList.toggle(
              'is-after',
              stepIndex > activeIndex
            );

            step.setAttribute(
              'aria-hidden',
              isActive ? 'false' : 'true'
            );
          } else {
            step.classList.remove(
              'is-before',
              'is-after'
            );

            step.removeAttribute(
              'aria-hidden'
            );
          }
        }
      );
    }


    /* ======================================================
       MOBILE SCROLL MODE
       ====================================================== */

    function startMobileMode() {
      isScrollMode = true;


      /*
       This controls how much natural scrolling
       is allocated to each step.
      */

      const requestedDistance =
        parseFloat(
          section.dataset
            .stepScrollDistance
        ) || 70;

      const distancePerStep =
        Math.max(
          40,
          Math.min(
            100,
            requestedDistance
          )
        );


      /*
       100svh creates the visible sticky viewport.

       Each step then receives its own additional
       scroll distance.

       Example:
       100 + (3 × 70) = 310svh.
      */

      const totalSectionHeight =
        100 +
        (
          steps.length *
          distancePerStep
        );

      section.style.setProperty(
        '--ericka-steps-scroll-height',
        totalSectionHeight + 'svh'
      );

      section.setAttribute(
        'data-ericka-steps-scroll-active',
        'true'
      );


      let frameId = null;


      /* ----------------------------------------------------
         CALCULATE CURRENT STEP FROM PAGE POSITION
         ---------------------------------------------------- */

      function updateFromScroll() {
        frameId = null;

        const sectionRect =
          section.getBoundingClientRect();

        const viewportHeight =
          window.innerHeight ||
          document.documentElement.clientHeight;

        const totalScrollDistance =
          Math.max(
            section.offsetHeight -
              viewportHeight,
            1
          );


        /*
         When the top of the section reaches
         the top of the viewport:

         sectionRect.top = 0
         progress = 0

         When the sticky sequence finishes:

         progress = 1
        */

        const distanceTravelled =
          -sectionRect.top;

        const progress =
          Math.max(
            0,
            Math.min(
              1,
              distanceTravelled /
                totalScrollDistance
            )
          );


        let nextIndex =
          Math.floor(
            progress * steps.length
          );

        /*
         At exactly 100%, Math.floor would
         return the number of steps.
        */

        nextIndex = Math.min(
          steps.length - 1,
          nextIndex
        );

        activateStep(nextIndex);
      }


      /* ----------------------------------------------------
         LIMIT SCROLL CALCULATIONS TO ONE PER FRAME
         ---------------------------------------------------- */

      function requestScrollUpdate() {
        if (frameId !== null) return;

        frameId =
          window.requestAnimationFrame(
            updateFromScroll
          );
      }


      window.addEventListener(
        'scroll',
        requestScrollUpdate,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        requestScrollUpdate
      );

      window.addEventListener(
        'orientationchange',
        requestScrollUpdate
      );


      if (window.visualViewport) {
        window.visualViewport.addEventListener(
          'resize',
          requestScrollUpdate
        );
      }


      activateStep(
        activeIndex,
        true
      );

      updateFromScroll();


      /* ----------------------------------------------------
         MOBILE CLEANUP
         ---------------------------------------------------- */

      return function stopMobileMode() {
        window.removeEventListener(
          'scroll',
          requestScrollUpdate
        );

        window.removeEventListener(
          'resize',
          requestScrollUpdate
        );

        window.removeEventListener(
          'orientationchange',
          requestScrollUpdate
        );

        if (window.visualViewport) {
          window.visualViewport
            .removeEventListener(
              'resize',
              requestScrollUpdate
            );
        }

        if (frameId !== null) {
          window.cancelAnimationFrame(
            frameId
          );

          frameId = null;
        }
      };
    }


    /* ======================================================
   DESKTOP AUTOMATIC ROTATION + HOVER
   ====================================================== */

function startDesktopMode() {
  isScrollMode = false;

  section.removeAttribute(
    'data-ericka-steps-scroll-active'
  );

  section.style.removeProperty(
    '--ericka-steps-scroll-height'
  );

  activateStep(
    activeIndex,
    true
  );


  let timer = null;

  const supportsHover =
    window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    ).matches;


  /* ----------------------------------------------------
     STOP CURRENT ROTATION
     ---------------------------------------------------- */

  function stopRotation() {
    if (timer === null) return;

    window.clearInterval(timer);

    if (
      section._erickaStepsTimer === timer
    ) {
      section._erickaStepsTimer = null;
    }

    timer = null;
  }


  /* ----------------------------------------------------
     START / RESTART ROTATION

     The full rotation delay starts again from the
     currently active step.
     ---------------------------------------------------- */

  function startRotation() {
    stopRotation();

    if (
      reducedMotionMedia.matches ||
      steps.length <= 1
    ) {
      return;
    }

    timer = window.setInterval(
      function () {
        const nextIndex =
          (activeIndex + 1) %
          steps.length;

        activateStep(nextIndex);
      },
      rotationSpeed
    );

    section._erickaStepsTimer =
      timer;
  }


  /* ----------------------------------------------------
     DESKTOP HOVER
     ---------------------------------------------------- */

  function handleStepEnter(event) {
    const hoveredStep =
      event.currentTarget;

    const hoveredIndex =
      steps.indexOf(hoveredStep);

    if (hoveredIndex < 0) return;

    /*
     Pause the automatic animation while the user
     is interacting with a step.
    */

    stopRotation();

    activateStep(
      hoveredIndex
    );
  }


  function handleStepLeave() {
    /*
     Restart the complete timer after the mouse
     leaves the hovered step.
    */

    startRotation();
  }


  if (supportsHover) {
    steps.forEach(
      function (step) {
        step.addEventListener(
          'mouseenter',
          handleStepEnter
        );

        step.addEventListener(
          'mouseleave',
          handleStepLeave
        );
      }
    );
  }


  /* ----------------------------------------------------
     INITIAL ROTATION
     ---------------------------------------------------- */

  startRotation();


  /* ----------------------------------------------------
     DESKTOP CLEANUP
     ---------------------------------------------------- */

  return function stopDesktopMode() {
    stopRotation();

    if (supportsHover) {
      steps.forEach(
        function (step) {
          step.removeEventListener(
            'mouseenter',
            handleStepEnter
          );

          step.removeEventListener(
            'mouseleave',
            handleStepLeave
          );
        }
      );
    }
  };
}


    /* ======================================================
       SWITCH BETWEEN MOBILE AND DESKTOP
       ====================================================== */

    function applyResponsiveMode() {
      modeCleanup();

      modeCleanup =
        function () {};


      if (
        mobileMedia.matches &&
        steps.length > 1
      ) {
        modeCleanup =
          startMobileMode();
      } else {
        modeCleanup =
          startDesktopMode();
      }
    }


    function handleMediaChange() {
      applyResponsiveMode();
    }


    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener(
        'change',
        handleMediaChange
      );
    } else {
      /*
       Older Safari fallback.
      */

      mobileMedia.addListener(
        handleMediaChange
      );
    }


    applyResponsiveMode();


    /* ======================================================
       COMPLETE SECTION CLEANUP
       ====================================================== */

    section._erickaStepsCleanup =
      function () {
        modeCleanup();

        if (
          mobileMedia.removeEventListener
        ) {
          mobileMedia.removeEventListener(
            'change',
            handleMediaChange
          );
        } else {
          mobileMedia.removeListener(
            handleMediaChange
          );
        }

        section.removeAttribute(
          'data-ericka-steps-scroll-active'
        );

        section.style.removeProperty(
          '--ericka-steps-scroll-height'
        );

        steps.forEach(
          function (step) {
            step.classList.remove(
              'is-before',
              'is-after'
            );

            step.removeAttribute(
              'aria-hidden'
            );
          }
        );
      };
  }


  /* ========================================================
     INITIALIZE ALL SECTIONS
     ======================================================== */

  function initErickaSteps(root) {
    getSections(root).forEach(
      setupStepsSection
    );
  }


  /* ========================================================
     NORMAL PAGE LOAD
     ======================================================== */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initErickaSteps(
          document
        );
      }
    );
  } else {
    initErickaSteps(
      document
    );
  }


  /* ========================================================
     SHOPIFY THEME EDITOR
     ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initErickaSteps(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:select',
    function (event) {
      initErickaSteps(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      getSections(
        event.target
      ).forEach(
        function (section) {
          if (
            typeof section
              ._erickaStepsCleanup ===
            'function'
          ) {
            section
              ._erickaStepsCleanup();
          }
        }
      );
    }
  );

})();

/* ==========================================================
   ERICKA HOME - LOOKS

   Desktop:
   Normal 4-card grid.

   Mobile:
   Sticky, scroll-driven look sequence.
   ========================================================== */

(function () {
  const SECTION_SELECTOR =
    '[data-ericka-looks-section]';

  const LOOK_SELECTOR =
    '[data-ericka-look]';

  const MOBILE_QUERY =
    '(max-width: 767px)';


  /* ========================================================
     FIND SECTIONS INSIDE A GIVEN ROOT
     ======================================================== */

  function getSections(root) {
    const scope = root || document;

    if (
      scope.matches &&
      scope.matches(SECTION_SELECTOR)
    ) {
      return [scope];
    }

    return Array.from(
      scope.querySelectorAll(
        SECTION_SELECTOR
      )
    );
  }


  /* ========================================================
     INITIALIZE ONE SECTION
     ======================================================== */

  function setupLooksSection(section) {

    /*
     Clean up any previous initialization.
     Useful inside the Shopify Theme Editor.
    */

    if (
      typeof section._erickaLooksCleanup ===
      'function'
    ) {
      section._erickaLooksCleanup();
    }


    const looks = Array.from(
      section.querySelectorAll(
        LOOK_SELECTOR
      )
    );

    const dots = Array.from(
      section.querySelectorAll(
        '[data-ericka-look-dot]'
      )
    );

    if (!looks.length) return;


    let activeIndex = looks.findIndex(
      function (look) {
        return look.classList.contains(
          'is-active'
        );
      }
    );

    if (activeIndex < 0) {
      activeIndex = 0;
    }


    let hasRendered = false;
    let isScrollMode = false;

    let modeCleanup = function () {};

    const mobileMedia =
      window.matchMedia(
        MOBILE_QUERY
      );


    /* ======================================================
       ACTIVATE A LOOK
       ====================================================== */

    function activateLook(index, forceUpdate) {
      const nextIndex =
        Math.max(
          0,
          Math.min(
            looks.length - 1,
            index
          )
        );

      if (
        hasRendered &&
        nextIndex === activeIndex &&
        !forceUpdate
      ) {
        return;
      }

      activeIndex = nextIndex;
      hasRendered = true;


      looks.forEach(
        function (look, lookIndex) {
          const isActive =
            lookIndex === activeIndex;

          look.classList.toggle(
            'is-active',
            isActive
          );


          /*
           Direction classes are only needed
           for the mobile scroll animation.
          */

          if (isScrollMode) {
            look.classList.toggle(
              'is-before',
              lookIndex < activeIndex
            );

            look.classList.toggle(
              'is-after',
              lookIndex > activeIndex
            );

            look.setAttribute(
              'aria-hidden',
              isActive ? 'false' : 'true'
            );
          } else {
            look.classList.remove(
              'is-before',
              'is-after'
            );

            look.removeAttribute(
              'aria-hidden'
            );
          }
        }
      );
      dots.forEach(
      function (dot, dotIndex) {
        dot.classList.toggle(
          'is-active',
          dotIndex === activeIndex
        );

        dot.setAttribute(
          'aria-current',
          dotIndex === activeIndex
            ? 'true'
            : 'false'
        );
      }
    );
    }

/* ======================================================
   MOBILE SCROLL MODE
   ====================================================== */

function startMobileMode() {
  isScrollMode = true;

  const container =
    section.querySelector(
      '.ericka-home-container'
    );

  const triggerElement =
    section.querySelector(
      '.ericka-home-looks__subheading'
    );

  /*
   * Scroll allocated to each Look.
   * 70 = approximately 70% of viewport height.
   */
  const distancePerLookVH =
    70;


  let viewportHeight =
    window.innerHeight ||
    document.documentElement.clientHeight;


  let triggerOffset = 0;

  let distancePerLookPx =
    viewportHeight *
    (
      distancePerLookVH / 100
    );

  let frameId = null;


  /* ====================================================
     CALCULATE LAYOUT
     ==================================================== */

  function calculateLayout() {

    viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight;


    /*
     * Measure where the subheading sits
     * inside the sticky container.
     *
     * When the container sticks at
     * -triggerOffset, the subheading
     * reaches top: 0.
     */

    if (
      container &&
      triggerElement
    ) {

      const containerRect =
        container.getBoundingClientRect();

      const triggerRect =
        triggerElement.getBoundingClientRect();


      triggerOffset =
        Math.max(
          0,
          triggerRect.top -
          containerRect.top - 80
        );


    } else {

      triggerOffset = 0;

    }


    container?.style.setProperty(
      '--ericka-looks-sticky-offset',
      triggerOffset + 'px'
    );


    distancePerLookPx =
      viewportHeight *
      (
        distancePerLookVH / 100
      );


    /*
     * We need:
     *
     * viewport
     * + distance before subtitle reaches top
     * + full scroll distance for every Look
     */

    const totalSectionHeight =
      viewportHeight +
      triggerOffset +
      (
        looks.length *
        distancePerLookPx
      );


    section.style.setProperty(
      '--ericka-looks-scroll-height',
      totalSectionHeight + 'px'
    );

  }


  section.setAttribute(
    'data-ericka-looks-scroll-active',
    'true'
  );


  calculateLayout();


  /* ====================================================
     UPDATE ACTIVE LOOK
     ==================================================== */

  function updateFromScroll() {
    frameId = null;


    const sectionRect =
      section.getBoundingClientRect();


    /*
     * Nothing happens until the section
     * has travelled enough for the
     * subheading to reach the top.
     */

    const distanceTravelled =
      Math.max(
        0,
        -sectionRect.top -
        triggerOffset
      );


    /*
     * One fixed scroll segment per Look.
     *
     * This avoids progress calculations
     * jumping directly from 1 to 4.
     */

    let nextIndex =
      Math.floor(
        distanceTravelled /
        distancePerLookPx
      );


    nextIndex =
      Math.max(
        0,
        Math.min(
          looks.length - 1,
          nextIndex
        )
      );


    activateLook(
      nextIndex
    );
  }


  /* ====================================================
     REQUEST ONE UPDATE PER FRAME
     ==================================================== */

  function requestScrollUpdate() {

    if (frameId !== null) return;


    frameId =
      window.requestAnimationFrame(
        updateFromScroll
      );

  }


  /* ====================================================
     RESIZE
     ==================================================== */

  function handleResize() {

    calculateLayout();

    requestScrollUpdate();

  }


  window.addEventListener(
    'scroll',
    requestScrollUpdate,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    handleResize
  );

  window.addEventListener(
    'orientationchange',
    handleResize
  );


  if (window.visualViewport) {

    window.visualViewport.addEventListener(
      'resize',
      handleResize
    );

  }


  activateLook(
    0,
    true
  );

  updateFromScroll();


  /* ====================================================
     MOBILE CLEANUP
     ==================================================== */

  return function stopMobileMode() {

    window.removeEventListener(
      'scroll',
      requestScrollUpdate
    );

    window.removeEventListener(
      'resize',
      handleResize
    );

    window.removeEventListener(
      'orientationchange',
      handleResize
    );


    if (window.visualViewport) {

      window.visualViewport.removeEventListener(
        'resize',
        handleResize
      );

    }


    if (frameId !== null) {

      window.cancelAnimationFrame(
        frameId
      );

      frameId = null;

    }


    if (container) {

      container.style.removeProperty(
        '--ericka-looks-sticky-offset'
      );

    }

  };
}



    /* ======================================================
       DESKTOP MODE
       ====================================================== */

    function startDesktopMode() {
      isScrollMode = false;

      section.removeAttribute(
        'data-ericka-looks-scroll-active'
      );

      section.style.removeProperty(
        '--ericka-looks-scroll-height'
      );


      /*
       Desktop is a normal grid, so all cards
       should remain visible.
      */

      looks.forEach(
        function (look) {
          look.classList.remove(
            'is-active',
            'is-before',
            'is-after'
          );

          look.removeAttribute(
            'aria-hidden'
          );
        }
      );


      return function () {};
    }


    /* ======================================================
       SWITCH BETWEEN MOBILE AND DESKTOP
       ====================================================== */

    function applyResponsiveMode() {
      modeCleanup();

      modeCleanup =
        function () {};


      if (
        mobileMedia.matches &&
        looks.length > 1
      ) {
        modeCleanup =
          startMobileMode();
      } else {
        modeCleanup =
          startDesktopMode();
      }
    }


    function handleMediaChange() {
      applyResponsiveMode();
    }


    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener(
        'change',
        handleMediaChange
      );
    } else {
      /*
       Older Safari fallback.
      */

      mobileMedia.addListener(
        handleMediaChange
      );
    }


    applyResponsiveMode();


    /* ======================================================
       COMPLETE SECTION CLEANUP
       ====================================================== */

    section._erickaLooksCleanup =
      function () {
        modeCleanup();

        if (
          mobileMedia.removeEventListener
        ) {
          mobileMedia.removeEventListener(
            'change',
            handleMediaChange
          );
        } else {
          mobileMedia.removeListener(
            handleMediaChange
          );
        }

        section.removeAttribute(
          'data-ericka-looks-scroll-active'
        );

        section.style.removeProperty(
          '--ericka-looks-scroll-height'
        );

        looks.forEach(
          function (look) {
            look.classList.remove(
              'is-before',
              'is-after'
            );

            look.removeAttribute(
              'aria-hidden'
            );
          }
        );
      };
  }


  /* ========================================================
     INITIALIZE ALL SECTIONS
     ======================================================== */

  function initErickaLooks(root) {
    getSections(root).forEach(
      setupLooksSection
    );
  }


  /* ========================================================
     NORMAL PAGE LOAD
     ======================================================== */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initErickaLooks(
          document
        );
      }
    );
  } else {
    initErickaLooks(
      document
    );
  }


  /* ========================================================
     SHOPIFY THEME EDITOR
     ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initErickaLooks(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:select',
    function (event) {
      initErickaLooks(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      getSections(
        event.target
      ).forEach(
        function (section) {
          if (
            typeof section
              ._erickaLooksCleanup ===
            'function'
          ) {
            section
              ._erickaLooksCleanup();
          }
        }
      );
    }
  );

})();

/* ==========================================================
   ERICKA HOME - PRODUCTS
   Infinite product carousel
   ========================================================== */

(function () {
  const SECTION_SELECTOR =
    '[data-ericka-products-section]';


  /* ========================================================
     FIND SECTIONS
     ======================================================== */

  function getSections(root) {
    const scope = root || document;

    if (
      scope.matches &&
      scope.matches(SECTION_SELECTOR)
    ) {
      return [scope];
    }

    return Array.from(
      scope.querySelectorAll(
        SECTION_SELECTOR
      )
    );
  }


  /* ========================================================
     INITIALIZE SECTION
     ======================================================== */

  function setupProductsSection(section) {

    if (
      typeof section._erickaProductsCleanup ===
      'function'
    ) {
      section._erickaProductsCleanup();
    }


    const viewport =
      section.querySelector(
        '[data-ericka-products-viewport]'
      );

    const track =
      section.querySelector(
        '[data-ericka-products-track]'
      );

    const prevButton =
      section.querySelector(
        '[data-ericka-products-prev]'
      );

    const nextButton =
      section.querySelector(
        '[data-ericka-products-next]'
      );

    const navigation =
      section.querySelector(
        '[data-ericka-products-navigation]'
      );


    if (!viewport || !track) return;


    /* ======================================================
       REMOVE OLD CLONES
       Important for Shopify Theme Editor.
       ====================================================== */

    track
      .querySelectorAll(
        '[data-ericka-product-clone]'
      )
      .forEach(
        function (clone) {
          clone.remove();
        }
      );


    const spacer =
      track.querySelector(
        '[data-ericka-products-start-spacer]'
      );


    const originalCards =
      Array.from(
        track.querySelectorAll(
          '[data-ericka-product-card]'
        )
      ).filter(
        function (card) {
          return !card.hasAttribute(
            'data-ericka-product-clone'
          );
        }
      );


    if (!originalCards.length) return;


    const total =
      originalCards.length;


    let currentIndex = 0;

    let isAnimating = false;

    let resizeFrame = null;

    let cloneCount = 0;


    /* ======================================================
       GAP
       ====================================================== */

    function getGap() {
      const styles =
        window.getComputedStyle(track);

      return (
        parseFloat(styles.columnGap) ||
        parseFloat(styles.gap) ||
        0
      );
    }


    /* ======================================================
       CREATE INFINITE CLONES
       ====================================================== */

    function createClones() {

      track
        .querySelectorAll(
          '[data-ericka-product-clone]'
        )
        .forEach(
          function (clone) {
            clone.remove();
          }
        );


      const cardWidth =
        originalCards[0]
          .getBoundingClientRect()
          .width;

      const viewportWidth =
        viewport
          .getBoundingClientRect()
          .width;

      const gap =
        getGap();


      cloneCount =
        Math.min(
          total,
          Math.max(
            1,
            Math.ceil(
              viewportWidth /
              (cardWidth + gap)
            ) + 1
          )
        );


      /*
       Clone products from the END
       and place them before the spacer.
      */

      const beforeFragment =
        document.createDocumentFragment();


      for (
        let i = total - cloneCount;
        i < total;
        i++
      ) {

        const clone =
          originalCards[i]
            .cloneNode(true);

        clone.setAttribute(
          'data-ericka-product-clone',
          'true'
        );

        clone.setAttribute(
          'aria-hidden',
          'true'
        );

        beforeFragment.appendChild(
          clone
        );
      }


      if (spacer) {
        track.insertBefore(
          beforeFragment,
          spacer
        );
      }


      /*
       Clone products from the START
       and append them after the real cards.
      */

      for (
        let i = 0;
        i < cloneCount;
        i++
      ) {

        const clone =
          originalCards[i]
            .cloneNode(true);

        clone.setAttribute(
          'data-ericka-product-clone',
          'true'
        );

        clone.setAttribute(
          'aria-hidden',
          'true'
        );

        track.appendChild(
          clone
        );
      }

    }


    /* ======================================================
       GET REAL CARD POSITION
       ====================================================== */

    function getRealCard(index) {
      return originalCards[index];
    }


    /* ======================================================
       MOVE TRACK
       ====================================================== */

    function moveToRealIndex(
      index,
      animate
    ) {

      const card =
        getRealCard(index);

      if (!card) return;


      if (!animate) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }


      const offset =
        card.offsetLeft;


      /*
       Product 1 gets the 56px spacer visible
       at the beginning.

       From Product 2 onward the spacer
       naturally scrolls away.
      */

      let targetOffset =
        offset;


      if (
        index === 0 &&
        spacer
      ) {
        targetOffset -=
          spacer.offsetWidth;
      }


      track.style.transform =
        'translate3d(' +
        (-targetOffset) +
        'px, 0, 0)';


      if (!animate) {

        track.offsetHeight;

        track.style.transition = '';
      }

    }


    /* ======================================================
       DOTS
       ====================================================== */

    function createNavigation() {

      if (!navigation) return;


      navigation.innerHTML = '';


      originalCards.forEach(
        function (_, index) {

          const dot =
            document.createElement(
              'button'
            );

          dot.type = 'button';

          dot.className =
            'ericka-home-products__nav-dot';

          dot.setAttribute(
            'aria-label',
            'Go to product ' +
              (index + 1)
          );


          dot.addEventListener(
            'click',
            function () {

              if (isAnimating) return;

              currentIndex = index;

              updateNavigation();

              moveToRealIndex(
                currentIndex,
                true
              );

            }
          );


          navigation.appendChild(
            dot
          );

        }
      );


      updateNavigation();
    }


    function updateNavigation() {

      if (!navigation) return;


      const dots =
        navigation.querySelectorAll(
          '.ericka-home-products__nav-dot'
        );


      dots.forEach(
        function (dot, index) {

          dot.classList.toggle(
            'is-active',
            index === currentIndex
          );

        }
      );

    }


    /* ======================================================
       NEXT
       ====================================================== */

    function handleNext() {

      if (isAnimating) return;


      /*
       Normal movement while we're
       still inside the real products.
      */

      if (
        currentIndex <
        total - 1
      ) {

        isAnimating = true;

        currentIndex += 1;

        updateNavigation();

        moveToRealIndex(
          currentIndex,
          true
        );

        return;
      }


      /*
       We're on the final product.

       Animate toward the first cloned card.
      */

      const firstCloneAfter =
        track.querySelector(
          '[data-ericka-product-clone]'
        );


      const allTrackCards =
        Array.from(
          track.querySelectorAll(
            '[data-ericka-product-card]'
          )
        );


      const trailingClone =
        allTrackCards[
          allTrackCards.length -
          cloneCount
        ];


      if (!trailingClone) return;


      isAnimating = true;


      track.style.transform =
        'translate3d(' +
        (-trailingClone.offsetLeft) +
        'px, 0, 0)';


      currentIndex = 0;

      updateNavigation();
    }


    /* ======================================================
       PREVIOUS
       ====================================================== */

    function handlePrevious() {

      if (isAnimating) return;


      if (currentIndex > 0) {

        isAnimating = true;

        currentIndex -= 1;

        updateNavigation();

        moveToRealIndex(
          currentIndex,
          true
        );

        return;
      }


      /*
       First real product:
       move to previous clone.
      */

      const clones =
        Array.from(
          track.querySelectorAll(
            '[data-ericka-product-clone]'
          )
        );


      const previousClone =
        clones[
          cloneCount - 1
        ];


      if (!previousClone) return;


      isAnimating = true;


      track.style.transform =
        'translate3d(' +
        (-previousClone.offsetLeft) +
        'px, 0, 0)';


      currentIndex =
        total - 1;

      updateNavigation();
    }


    /* ======================================================
       AFTER TRANSITION
       Reposition invisibly when we reached clones.
       ====================================================== */

    function handleTransitionEnd(event) {

      if (
        event.target !== track ||
        event.propertyName !==
          'transform'
      ) {
        return;
      }


      /*
       After the visible animation completes,
       instantly return to the corresponding
       REAL card.

       The clone and real card are identical,
       so the user sees no jump.
      */

      moveToRealIndex(
        currentIndex,
        false
      );


      isAnimating = false;
    }


    /* ======================================================
       PRODUCT IMAGE DOTS
       ====================================================== */

    function initializeImageGalleries() {

      const cards =
        Array.from(
          track.querySelectorAll(
            '[data-ericka-product-card]'
          )
        );


      cards.forEach(
        function (card) {

          const images =
            Array.from(
              card.querySelectorAll(
                '[data-ericka-product-image]'
              )
            );

          const dots =
            Array.from(
              card.querySelectorAll(
                '[data-ericka-product-image-dot]'
              )
            );


          if (
            images.length <= 1 ||
            !dots.length
          ) {
            return;
          }


          dots.forEach(
            function (dot, index) {

              dot.addEventListener(
                'click',
                function () {

                  images.forEach(
                    function (
                      image,
                      imageIndex
                    ) {

                      image.classList.toggle(
                        'is-active',
                        imageIndex === index
                      );

                    }
                  );


                  dots.forEach(
                    function (
                      currentDot,
                      dotIndex
                    ) {

                      currentDot.classList.toggle(
                        'is-active',
                        dotIndex === index
                      );

                    }
                  );

                }
              );

            }
          );

        }
      );

    }

    /* ======================================================
   DRAG / SWIPE PRODUCTS
   ====================================================== */

let productPointerId = null;

let productStartX = 0;
let productCurrentX = 0;

let productIsDragging = false;
let suppressProductClick = false;

const productSwipeThreshold = 45;
const productDragThreshold = 8;


function handleProductPointerDown(event) {

  if (!viewport || isAnimating) return;


  /*
   * Do not start dragging from interactive controls.
   */

  if (
    event.target.closest(
      'button, ' +
      'a, ' +
      'input, ' +
      'select, ' +
      'textarea, ' +
      '[data-ericka-product-image-dot], ' +
      '[data-ericka-products-prev], ' +
      '[data-ericka-products-next], ' +
      '.ericka-home-products__nav-dot'
    )
  ) {
    return;
  }


  productPointerId =
    event.pointerId;


  productStartX =
    event.clientX;


  productCurrentX =
    event.clientX;


  productIsDragging = true;

  suppressProductClick = false;


  viewport.classList.add(
    'is-dragging'
  );


  if (
    viewport.setPointerCapture &&
    productPointerId !== null
  ) {

    try {

      viewport.setPointerCapture(
        productPointerId
      );

    } catch (error) {
      /* Ignore capture errors */
    }

  }

}


function handleProductPointerMove(event) {

  if (
    !productIsDragging ||
    event.pointerId !== productPointerId
  ) {
    return;
  }


  productCurrentX =
    event.clientX;


  const distance =
    productCurrentX -
    productStartX;


  if (
    Math.abs(distance) >
    productDragThreshold
  ) {

    suppressProductClick = true;

  }

}


function finishProductPointerGesture(event) {

  if (
    !productIsDragging ||
    (
      productPointerId !== null &&
      event.pointerId !==
        productPointerId
    )
  ) {
    return;
  }


  productIsDragging = false;


  viewport.classList.remove(
    'is-dragging'
  );


  const distance =
    productCurrentX -
    productStartX;


  /*
   * Drag left = next product
   */

  if (
    distance <=
    -productSwipeThreshold
  ) {

    handleNext();

  }


  /*
   * Drag right = previous product
   */

  else if (
    distance >=
    productSwipeThreshold
  ) {

    handlePrevious();

  }


  if (
    viewport.releasePointerCapture &&
    productPointerId !== null
  ) {

    try {

      viewport.releasePointerCapture(
        productPointerId
      );

    } catch (error) {
      /* Ignore release errors */
    }

  }


  productPointerId = null;


  /*
   * Prevent accidental clicks immediately
   * after a drag.
   */

  if (suppressProductClick) {

    window.setTimeout(
      function () {

        suppressProductClick = false;

      },
      250
    );

  }

}


viewport.addEventListener(
  'pointerdown',
  handleProductPointerDown
);


viewport.addEventListener(
  'pointermove',
  handleProductPointerMove
);


viewport.addEventListener(
  'pointerup',
  finishProductPointerGesture
);


viewport.addEventListener(
  'pointercancel',
  finishProductPointerGesture
);


    /* ======================================================
       RESIZE
       ====================================================== */

    function recalculate() {

      if (resizeFrame !== null) {
        window.cancelAnimationFrame(
          resizeFrame
        );
      }


      resizeFrame =
        window.requestAnimationFrame(
          function () {

            resizeFrame = null;

            createClones();

            initializeImageGalleries();

            moveToRealIndex(
              currentIndex,
              false
            );

          }
        );
    }


    /* ======================================================
       EVENTS
       ====================================================== */

    if (prevButton) {
      prevButton.addEventListener(
        'click',
        handlePrevious
      );
    }


    if (nextButton) {
      nextButton.addEventListener(
        'click',
        handleNext
      );
    }


    track.addEventListener(
      'transitionend',
      handleTransitionEnd
    );


    window.addEventListener(
      'resize',
      recalculate
    );


    window.addEventListener(
      'orientationchange',
      recalculate
    );


    /* ======================================================
       INITIALIZATION
       ====================================================== */

    createClones();

    createNavigation();

    initializeImageGalleries();


    requestAnimationFrame(
      function () {

        moveToRealIndex(
          0,
          false
        );

      }
    );


    /* ======================================================
       CLEANUP
       ====================================================== */

    section._erickaProductsCleanup =
      function () {

        if (prevButton) {
          prevButton.removeEventListener(
            'click',
            handlePrevious
          );
        }

        if (nextButton) {
          nextButton.removeEventListener(
            'click',
            handleNext
          );
        }


        track.removeEventListener(
          'transitionend',
          handleTransitionEnd
        );


        window.removeEventListener(
          'resize',
          recalculate
        );

        window.removeEventListener(
          'orientationchange',
          recalculate
        );


        if (resizeFrame !== null) {
          window.cancelAnimationFrame(
            resizeFrame
          );
        }


        track.style.transform = '';
        track.style.transition = '';


        track
          .querySelectorAll(
            '[data-ericka-product-clone]'
          )
          .forEach(
            function (clone) {
              clone.remove();
            }
          );

      };

  }


  /* ========================================================
     INITIALIZE
     ======================================================== */

  function initErickaProducts(root) {

    getSections(root).forEach(
      setupProductsSection
    );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initErickaProducts(
          document
        );

      }
    );

  } else {

    initErickaProducts(
      document
    );

  }


  /* ========================================================
     SHOPIFY THEME EDITOR
     ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initErickaProducts(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:select',
    function (event) {

      initErickaProducts(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      getSections(
        event.target
      ).forEach(
        function (section) {

          if (
            typeof section
              ._erickaProductsCleanup ===
            'function'
          ) {

            section
              ._erickaProductsCleanup();

          }

        }
      );

    }
  );

})();
/* ==========================================================
   ERICKA HOME - ESSENTIALS

   Desktop:
   Normal card grid.

   Mobile:
   Sticky scroll-driven card sequence.
   ========================================================== */

(function () {

  const SECTION_SELECTOR =
    '[data-ericka-essentials-section]';

  const CARD_SELECTOR =
    '[data-ericka-essential]';

  const MOBILE_QUERY =
    '(max-width: 767px)';


  /* ========================================================
     FIND SECTIONS
     ======================================================== */

  function getSections(root) {

    const scope =
      root || document;


    if (
      scope.matches &&
      scope.matches(
        SECTION_SELECTOR
      )
    ) {
      return [scope];
    }


    return Array.from(
      scope.querySelectorAll(
        SECTION_SELECTOR
      )
    );

  }


  /* ========================================================
     SETUP ONE SECTION
     ======================================================== */

  function setupEssentialsSection(
    section
  ) {

    /* ------------------------------------------------------
       CLEAN PREVIOUS INITIALIZATION
       ------------------------------------------------------ */

    if (
      typeof section
        ._erickaEssentialsCleanup ===
      'function'
    ) {

      section
        ._erickaEssentialsCleanup();

    }


    const cards =
      Array.from(
        section.querySelectorAll(
          CARD_SELECTOR
        )
      );


    if (!cards.length) {
      return;
    }


    const mobileMedia =
      window.matchMedia(
        MOBILE_QUERY
      );


    let activeIndex = 0;

    let isMobileMode = false;

    let modeCleanup =
      function () {};


    /* ======================================================
       ACTIVATE CARD
       ====================================================== */

    function activateCard(
      requestedIndex,
      force
    ) {

      const newIndex =
        Math.max(
          0,
          Math.min(
            cards.length - 1,
            requestedIndex
          )
        );


      if (
        newIndex === activeIndex &&
        !force
      ) {
        return;
      }


      activeIndex =
        newIndex;


      cards.forEach(
        function (
          card,
          index
        ) {

          const isActive =
            index === activeIndex;


          card.classList.toggle(
            'is-active',
            isActive
          );


          if (isMobileMode) {

            card.classList.toggle(
              'is-before',
              index < activeIndex
            );


            card.classList.toggle(
              'is-after',
              index > activeIndex
            );


            card.setAttribute(
              'aria-hidden',
              isActive
                ? 'false'
                : 'true'
            );

          } else {

            card.classList.remove(
              'is-before',
              'is-after'
            );


            card.removeAttribute(
              'aria-hidden'
            );

          }

        }
      );

    }


    /* ======================================================
       MOBILE MODE
       ====================================================== */

    function startMobileMode() {

      isMobileMode = true;


      /*
       Each card gets 90svh of natural scroll.

       Four cards:
       100 + (4 × 90)
       = 460svh

       Long enough to feel controlled,
       but much shorter than the 580svh
       version we tested.
      */

      const scrollPerCard =
        90;


      const totalHeight =
        100 +
        (
          cards.length *
          scrollPerCard
        );


      section.style.setProperty(
        '--ericka-essentials-scroll-height',
        totalHeight + 'svh'
      );


      section.setAttribute(
        'data-ericka-essentials-scroll-active',
        'true'
      );


      let frameId = null;


      /* ====================================================
         SCROLL CALCULATION
         ==================================================== */

      function updateFromScroll() {

        frameId = null;


        const rect =
          section
            .getBoundingClientRect();


        const viewportHeight =
          window.innerHeight ||
          document
            .documentElement
            .clientHeight;


        const scrollableDistance =
          Math.max(
            section.offsetHeight -
              viewportHeight,
            1
          );


        /*
         rect.top = 0
         means sticky sequence begins.

         Negative rect.top tells us how far
         we have moved through the section.
        */

        const travelled =
          Math.max(
            0,
            -rect.top
          );


        const progress =
          Math.max(
            0,
            Math.min(
              1,
              travelled /
              scrollableDistance
            )
          );


        /*
         Split the entire sequence evenly
         between all cards.

         Example with four cards:

         0.00 - 0.25 → card 1
         0.25 - 0.50 → card 2
         0.50 - 0.75 → card 3
         0.75 - 1.00 → card 4
        */

        let newIndex =
          Math.floor(
            progress *
            cards.length
          );


        newIndex =
          Math.min(
            cards.length - 1,
            newIndex
          );


        activateCard(
          newIndex,
          false
        );

      }


      /* ====================================================
         REQUEST ONE UPDATE PER FRAME
         ==================================================== */

      function requestUpdate() {

        if (
          frameId !== null
        ) {
          return;
        }


        frameId =
          window.requestAnimationFrame(
            updateFromScroll
          );

      }


      /* ====================================================
         EVENTS
         ==================================================== */

      window.addEventListener(
        'scroll',
        requestUpdate,
        {
          passive: true
        }
      );


      window.addEventListener(
        'resize',
        requestUpdate
      );


      window.addEventListener(
        'orientationchange',
        requestUpdate
      );


      if (
        window.visualViewport
      ) {

        window.visualViewport
          .addEventListener(
            'resize',
            requestUpdate
          );

      }


      /* ====================================================
         INITIAL STATE
         ==================================================== */

      activateCard(
        activeIndex,
        true
      );


      updateFromScroll();


      /* ====================================================
         MOBILE CLEANUP
         ==================================================== */

      return function stopMobileMode() {

        window.removeEventListener(
          'scroll',
          requestUpdate
        );


        window.removeEventListener(
          'resize',
          requestUpdate
        );


        window.removeEventListener(
          'orientationchange',
          requestUpdate
        );


        if (
          window.visualViewport
        ) {

          window.visualViewport
            .removeEventListener(
              'resize',
              requestUpdate
            );

        }


        if (
          frameId !== null
        ) {

          window.cancelAnimationFrame(
            frameId
          );


          frameId = null;

        }

      };

    }


    /* ======================================================
       DESKTOP MODE
       ====================================================== */

    function startDesktopMode() {

      isMobileMode = false;


      section.removeAttribute(
        'data-ericka-essentials-scroll-active'
      );


      section.style.removeProperty(
        '--ericka-essentials-scroll-height'
      );


      /*
       Essentials is a normal grid on desktop.
       No active/inactive state.
      */

      cards.forEach(
        function (card) {

          card.classList.remove(
            'is-active',
            'is-before',
            'is-after'
          );


          card.removeAttribute(
            'aria-hidden'
          );

        }
      );


      return function () {};

    }


    /* ======================================================
       SWITCH RESPONSIVE MODE
       ====================================================== */

    function applyMode() {

      modeCleanup();


      modeCleanup =
        function () {};


      if (
        mobileMedia.matches &&
        cards.length > 1
      ) {

        modeCleanup =
          startMobileMode();

      } else {

        modeCleanup =
          startDesktopMode();

      }

    }


    function handleMediaChange() {

      applyMode();

    }


    if (
      mobileMedia
        .addEventListener
    ) {

      mobileMedia.addEventListener(
        'change',
        handleMediaChange
      );

    } else {

      mobileMedia.addListener(
        handleMediaChange
      );

    }


    applyMode();


    /* ======================================================
       FULL CLEANUP
       ====================================================== */

    section._erickaEssentialsCleanup =
      function () {

        modeCleanup();


        if (
          mobileMedia
            .removeEventListener
        ) {

          mobileMedia
            .removeEventListener(
              'change',
              handleMediaChange
            );

        } else {

          mobileMedia
            .removeListener(
              handleMediaChange
            );

        }


        section.removeAttribute(
          'data-ericka-essentials-scroll-active'
        );


        section.style.removeProperty(
          '--ericka-essentials-scroll-height'
        );


        cards.forEach(
          function (card) {

            card.classList.remove(
              'is-active',
              'is-before',
              'is-after'
            );


            card.removeAttribute(
              'aria-hidden'
            );

          }
        );

      };

  }


  /* ========================================================
     INITIALIZE ALL ESSENTIAL SECTIONS
     ======================================================== */

  function initErickaEssentials(
    root
  ) {

    getSections(
      root
    ).forEach(
      setupEssentialsSection
    );

  }


  /* ========================================================
     NORMAL PAGE LOAD
     ======================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initErickaEssentials(
          document
        );

      }
    );

  } else {

    initErickaEssentials(
      document
    );

  }


  /* ========================================================
     SHOPIFY THEME EDITOR
     ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initErickaEssentials(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:select',
    function (event) {

      initErickaEssentials(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      getSections(
        event.target
      ).forEach(
        function (section) {

          if (
            typeof section
              ._erickaEssentialsCleanup ===
            'function'
          ) {

            section
              ._erickaEssentialsCleanup();

          }

        }
      );

    }
  );

})();

/* ==========================================================
   ERICKA HOME - BENEFITS MARQUEE
   Seamless infinite marquee
   ========================================================== */

(function () {

  const TRACK_SELECTOR =
    '[data-ericka-benefits-track]';

  const GROUP_SELECTOR =
    '[data-ericka-benefits-group]';


  function setupMarquee(track) {

    if (
      typeof track._erickaBenefitsCleanup ===
      'function'
    ) {
      track._erickaBenefitsCleanup();
    }


    /*
     Remove clones from previous initialization.
    */

    track
      .querySelectorAll(
        '[data-ericka-benefits-clone]'
      )
      .forEach(
        function (clone) {
          clone.remove();
        }
      );


    const originalGroup =
      track.querySelector(
        GROUP_SELECTOR
      );


    if (!originalGroup) return;


    let animationFrame = null;
    let resizeFrame = null;

    let position = 0;
    let groupWidth = 0;

    /*
     Pixels per second.
     Lower = slower.
    */

    const speed = 45;

    let previousTime = null;


    /* ======================================================
       CREATE ENOUGH COPIES
       ====================================================== */

    function buildCopies() {

      track
        .querySelectorAll(
          '[data-ericka-benefits-clone]'
        )
        .forEach(
          function (clone) {
            clone.remove();
          }
        );


      groupWidth =
        originalGroup
          .getBoundingClientRect()
          .width;


      if (!groupWidth) return;


      const viewportWidth =
        window.innerWidth;


      /*
       We want significantly more content than the
       visible viewport so a blank area can never
       reach the screen.

       +2 gives us additional safety on ultrawide
       monitors and during resizing.
      */

      const copiesNeeded =
        Math.max(
          2,
          Math.ceil(
            viewportWidth /
            groupWidth
          ) + 2
        );


      for (
        let i = 0;
        i < copiesNeeded;
        i++
      ) {

        const clone =
          originalGroup.cloneNode(true);


        clone.removeAttribute(
          'data-ericka-benefits-group'
        );


        clone.setAttribute(
          'data-ericka-benefits-clone',
          'true'
        );


        clone.setAttribute(
          'aria-hidden',
          'true'
        );


        track.appendChild(
          clone
        );

      }


      /*
       Keep our current position inside
       the first group's width.
      */

      position =
        position % groupWidth;


      track.style.transform =
        'translate3d(' +
        (-position) +
        'px, 0, 0)';

    }


    /* ======================================================
       ANIMATION
       ====================================================== */

    function animate(time) {

      if (previousTime === null) {
        previousTime = time;
      }


      const delta =
        Math.min(
          (time - previousTime) / 1000,
          0.05
        );


      previousTime = time;


      position +=
        speed * delta;


      /*
       As soon as one complete group has left
       the screen, reset by exactly its width.

       Since the following group is identical,
       there is no visible jump.
      */

      if (
        groupWidth &&
        position >= groupWidth
      ) {

        position -= groupWidth;

      }


      track.style.transform =
        'translate3d(' +
        (-position) +
        'px, 0, 0)';


      animationFrame =
        window.requestAnimationFrame(
          animate
        );

    }


    /* ======================================================
       RESIZE
       ====================================================== */

    function handleResize() {

      if (resizeFrame !== null) {
        window.cancelAnimationFrame(
          resizeFrame
        );
      }


      resizeFrame =
        window.requestAnimationFrame(
          function () {

            resizeFrame = null;

            buildCopies();

          }
        );

    }


    buildCopies();


    animationFrame =
      window.requestAnimationFrame(
        animate
      );


    window.addEventListener(
      'resize',
      handleResize
    );


    /* ======================================================
       CLEANUP
       ====================================================== */

    track._erickaBenefitsCleanup =
      function () {

        window.removeEventListener(
          'resize',
          handleResize
        );


        if (animationFrame !== null) {
          window.cancelAnimationFrame(
            animationFrame
          );
        }


        if (resizeFrame !== null) {
          window.cancelAnimationFrame(
            resizeFrame
          );
        }


        track
          .querySelectorAll(
            '[data-ericka-benefits-clone]'
          )
          .forEach(
            function (clone) {
              clone.remove();
            }
          );


        track.style.transform = '';

      };

  }


  function initMarquees(root) {

    const scope =
      root || document;


    if (
      scope.matches &&
      scope.matches(TRACK_SELECTOR)
    ) {

      setupMarquee(scope);

      return;

    }


    scope
      .querySelectorAll(
        TRACK_SELECTOR
      )
      .forEach(
        setupMarquee
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initMarquees(
          document
        );

      }
    );

  } else {

    initMarquees(
      document
    );

  }


  /* Shopify Theme Editor */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initMarquees(
        event.target
      );

    }
  );

})();


/* ==========================================================
   ERICKA HOME — MOBILE HEADER
   ========================================================== */

(function () {

  function initErickaMobileHeader(root) {

    const scope =
      root || document;

    const headers =
      scope.querySelectorAll
        ? scope.querySelectorAll(
            '[data-ericka-home-header]'
          )
        : [];


    headers.forEach(function (header) {

      const button =
        header.querySelector(
          '[data-ericka-mobile-menu-toggle]'
        );

      const menu =
        header.querySelector(
          '[data-ericka-mobile-menu]'
        );


      if (!button || !menu) return;


      function setMenu(open) {

        button.classList.toggle(
          'is-active',
          open
        );

        menu.classList.toggle(
          'is-open',
          open
        );

        button.setAttribute(
          'aria-expanded',
          open ? 'true' : 'false'
        );

        menu.setAttribute(
          'aria-hidden',
          open ? 'false' : 'true'
        );
      }


      button.addEventListener(
        'click',
        function () {

          const open =
            !menu.classList.contains(
              'is-open'
            );

          setMenu(open);

        }
      );


      menu.querySelectorAll('a').forEach(
        function (link) {

          link.addEventListener(
            'click',
            function () {
              setMenu(false);
            }
          );

        }
      );

    });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initErickaMobileHeader(document);
      }
    );

  } else {

    initErickaMobileHeader(document);

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initErickaMobileHeader(
        event.target
      );
    }
  );

})();

/* ==========================================================
   DESKTOP SIMPLE FADE ENTRANCES
   ========================================================== */

function initErickaDesktopFades() {

  if (
    !window.matchMedia('(min-width: 768px)').matches
  ) {
    return;
  }


  const elements =
    document.querySelectorAll(
      '.ericka-home-no-adhesive__box, ' +
      '.ericka-home-why-lace__image'
    );


  if (!elements.length) return;


  const observer =
    new IntersectionObserver(
      function (entries) {

        entries.forEach(
          function (entry) {

            if (!entry.isIntersecting) return;


            entry.target.classList.add(
              'is-entered'
            );


            observer.unobserve(
              entry.target
            );

          }
        );

      },

      {
        threshold: 0.2
      }
    );


  elements.forEach(
    function (element) {

      observer.observe(
        element
      );

    }
  );

}


initErickaDesktopFades();


/* ==========================================================
   DESKTOP SIMPLE FADE ENTRANCES
   ========================================================== */

function initErickaDesktopFades() {

  if (
    !window.matchMedia('(min-width: 768px)').matches
  ) {
    return;
  }


  const elements =
    document.querySelectorAll(
      '.ericka-home-no-adhesive__content-card, ' +
      '.ericka-home-why-lace__image-wrap'
    );


  if (!elements.length) return;


  const observer =
    new IntersectionObserver(
      function (entries) {

        entries.forEach(
          function (entry) {

            if (!entry.isIntersecting) return;


            entry.target.classList.add(
              'is-entered'
            );


            observer.unobserve(
              entry.target
            );

          }
        );

      },

      {
        threshold: 0.2
      }
    );


  elements.forEach(
    function (element) {

      observer.observe(
        element
      );

    }
  );

}


function initErickaHeroEntrance() {

  if (
    !window.matchMedia('(min-width: 768px)').matches
  ) {
    return;
  }

  const heroImage =
    document.querySelector(
      '.ericka-home-hero__media'
    );

  if (!heroImage) return;

  requestAnimationFrame(function () {

    requestAnimationFrame(function () {

      heroImage.classList.add(
        'is-entered'
      );

    });

  });

}

initErickaHeroEntrance();


const erickaSearchTrigger =
  document.querySelector(
    '[data-ericka-search-trigger]'
  );


if (erickaSearchTrigger) {

  erickaSearchTrigger.addEventListener(
    'click',
    function () {

      const nativeSearchTrigger =
        document.querySelector(
          '.header [data-search-trigger]'
        );


      if (nativeSearchTrigger) {

        nativeSearchTrigger.click();

      }

    }
  );

}
